<template>
	<v-container fluid >
		<v-layout row wrap>
			<v-flex sm8 md4 xs12 offset-sm2 offset-md4>
				<v-card class="pa-4">
					<v-card-text class="grey--text">
						<v-flex xs12>
							<InputField :label="$t('labels.opportunityId')"
									v-model="opportunity_id"
									@keyup.native.enter="search"></InputField>
						</v-flex>
						<v-layout text-xs-right>
						<v-flex xs12>
							<v-btn @click="search" color="grey lighten-1">{{$t('buttons.search')}}
							</v-btn>
						</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";

	export default {
		name: 'App',
		components: {InputField},
		data() {
			return {
				opportunity_id: ''
			}
		},
		watch: {

		},
		computed: {

		},
		methods: {
			search(){
				this.opportunity_id = this.opportunity_id.trim();
				this.opportunity_id = this.opportunity_id.toUpperCase();
				this.$router.push('/opportunities/' + this.opportunity_id);
			}
		},
		mounted() {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.opportunities'), href: '/#/opportunities', disabled: false}
			]);
		}
	}
</script>

<style scoped>
</style>
